import moment from "moment";
import { LoadState } from "../../constants/enums";
import { defaultPurchaseOrderItem } from "../purchase-order";
import {
  IGateEntry,
  IGateEntryItem,
  IGateEntryState,
} from "./gate-entry.types";

export const defaultGateEntryItem: IGateEntryItem = {
  ...defaultPurchaseOrderItem,
  purchase_order_uuid: "",
  purchase_order_no: "",
  po_quantity: 0,
  ge_quantity: 0,
};

export const defaultGateEntry: IGateEntry = {
  gate_entry_uuid: null,
  origin_from: null,
  origin_from_uuid: null,
  origin_from_document_no: null,
  origin_from_document_date: null,
  gate_entry_type: null,
  gate_entry_date: moment().format("YYYY-MM-DD"),
  project_uuid: null,
  project_name: null,
  po_date: null,
  po_data: [],
  vehicle_no: null,
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  billing_company_branch_state: null,
  vendor_uuid: "",
  vendor_name: "",
  vendor_email: "",
  vendor_phone_number: "",
  vendor_contact_name: "",
  registration_type: "",
  vendor_gstin: "",
  contact_name: null,
  phone_number: null,
  remark: null,
  invoice_items: [],
  attachments: [],
  status: "ACTIVE",
};
export const defaultGateEntryState: IGateEntryState = {
  gate_entry_list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  single_gate_entry: {
    data: defaultGateEntry,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
